import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import {
  Menu,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Badge,
  IconButton,
  Box,
  Divider,
  Button,
} from '@mui/material';
import {
  Notifications,
  Person,
  Assignment,
  Close,
  MarkEmailRead,
} from '@mui/icons-material';
import { markAsRead, markAllAsRead } from '../../store/slices/notificationsSlice';
import { formatDistanceToNow } from 'date-fns';

const NotificationPanel = ({ anchorEl, open, onClose }) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.notifications);

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'lead_assigned':
        return <Assignment color="primary" />;
      case 'new_lead':
        return <Person color="success" />;
      default:
        return <Notifications color="info" />;
    }
  };

  const handleMarkAsRead = (notificationId) => {
    dispatch(markAsRead(notificationId));
  };

  const handleMarkAllAsRead = () => {
    dispatch(markAllAsRead());
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { 
          width: 360, 
          maxHeight: 400,
          mt: 1 
        }
      }}
    >
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Notifications</Typography>
          <Box>
            {notifications.some(n => !n.is_read) && (
              <Button
                size="small"
                startIcon={<MarkEmailRead />}
                onClick={handleMarkAllAsRead}
              >
                Mark all read
              </Button>
            )}
            <IconButton size="small" onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <List sx={{ maxHeight: 300, overflow: 'auto' }}>
        {notifications.length === 0 ? (
          <ListItem>
            <ListItemText
              primary="No notifications"
              secondary="You're all caught up!"
            />
          </ListItem>
        ) : (
          notifications.slice(0, 10).map((notification) => (
            <React.Fragment key={notification.id}>
              <ListItem
                sx={{
                  backgroundColor: notification.is_read ? 'transparent' : 'action.hover',
                  cursor: 'pointer',
                }}
                onClick={() => handleMarkAsRead(notification.id)}
              >
                <ListItemIcon>
                  <Badge 
                    variant="dot" 
                    color="error" 
                    invisible={notification.is_read}
                  >
                    {getNotificationIcon(notification.type)}
                  </Badge>
                </ListItemIcon>
                <ListItemText
                  primary={notification.title}
                  secondary={
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {notification.message}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatDistanceToNow(new Date(notification.created_at), { 
                          addSuffix: true 
                        })}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))
        )}
      </List>

      {notifications.length > 10 && (
        <Box sx={{ p: 1, textAlign: 'center' }}>
          <Button size="small" onClick={() => Navigate('/notifications')}>
            View all notifications
          </Button>
        </Box>
      )}
    </Menu>
  );
};

export default NotificationPanel;